export default {
  root: {
    // color: 'rgba(0,0,0,0.4) !important'
  },
};
